// extracted by mini-css-extract-plugin
export default {"warn-icon":"warn-icon--tjGFq","warnIcon":"warn-icon--tjGFq"};